"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// Export data
var _default = exports.default = {
  domain: '',
  learnMore: {
    logo: {
      alt: 'SAP Logo',
      src: '/sites/all/modules/custom_concur/concur_sap_banner/images/sap-logo.png'
    },
    text: 'Concur adesso è parte di SAP',
    learn: {
      href: '/sap',
      text: 'Scopri di più'
    }
  },
  social: [{
    network: 'facebook',
    href: ''
  }, {
    network: 'twitter',
    href: ''
  }, {
    network: 'linkedin',
    href: ''
  }],
  support: {
    links: [{
      text: 'NEWSROOM',
      href: ''
    }, {
      text: 'DIVULGAZIONE LEGALE',
      href: '/divulgazione-legale'
    }, {
      text: 'CONTATTI',
      href: '/contatti'
    }],
    selector: 'SELEZIONE PAESE',
    modelTitle: 'Select your location:'
  },
  copyright: {
    text: '© Copyright @{year} Concur Technologies, Inc. All rights reserved.',
    links: [{
      text: 'Informativa sulla privacy',
      href: '/privacy-policy'
    }, {
      text: 'Condizioni di utilizzo',
      href: ''
    }]
  }
};